import type { ButtonHTMLAttributes, ReactNode } from 'react';
import { Loader2 } from 'lucide-react';

type Variant = 'primary' | 'secondary' | 'bordered' | 'destructive' | 'plain';

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: Variant;
  loading?: boolean;
  children: ReactNode;
  full?: boolean;
}

const variantClasses: Record<Variant, string> = {
  primary: 'bg-blue-600 text-white hover:bg-blue-700 disabled:opacity-50',
  secondary: 'bg-black/[0.06] dark:bg-white/10 text-current hover:bg-black/10 dark:hover:bg-white/15',
  bordered: 'border border-black/15 dark:border-white/20 text-current hover:bg-black/5 dark:hover:bg-white/10',
  destructive: 'bg-red-600 text-white hover:bg-red-700',
  plain: 'text-blue-600 dark:text-blue-400 hover:underline px-0',
};

export function Button({ variant = 'primary', loading, children, className = '', full, disabled, ...rest }: ButtonProps) {
  return (
    <button
      disabled={disabled || loading}
      className={
        `inline-flex items-center justify-center gap-2 rounded-xl px-4 py-2.5 text-[15px] font-medium transition-colors ${
          variant === 'plain' ? '' : 'active:scale-[0.98]'
        } disabled:cursor-not-allowed ${full ? 'w-full' : ''} ${variantClasses[variant]} ${className}`
      }
      {...rest}
    >
      {loading && <Loader2 size={16} className="animate-spin" />}
      {children}
    </button>
  );
}
